<template lang="pug">
.content
    setting-title(title="用户管理")
    div.iframe-header
        TableTitle(slot="icon", icon="fa fa-list", title="账户信息")
    iframe(src="https://registry.dmp.360.cn/user" frameborder="0" width="100%" height="100%" scrolling="no")
</template>
<script>
    const listener = function(e) {
        if (typeof e.data === 'number') {
            document.querySelector('iframe').height = e.data;
        }
    };

    export default {
        mounted(){
            window.addEventListener('message', listener);
        },
        destroyed () {
            window.removeEventListener('message', listener);
        }
    }
</script>
<style scoped>
.iframe-header {
    background-color: #fff;
    border-bottom: 1px solid rgb(227, 227, 227);
    padding: 5px 15px;
}
iframe {
    min-height: 500px;
}
</style>



// WEBPACK FOOTER //
// account.vue?2882fa32